var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-template"},[_c('p',[_vm._v(_vm._s(_vm.msg.kejianname))]),_c('p',[_vm._v(_vm._s(_vm._f("times")(_vm.msg.xuexidate)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }